import { View } from '../../primitives/View';
import { cn } from '../../utils/cn';
import type { SkeletonProps, SkeletonShape } from './Skeleton.types';
import { useInsideSkeletonPulse } from './SkeletonContext';
import { SkeletonPulse } from './SkeletonPulse';

/** `secondary-200` is a palette token, so the shapes invert in dark mode. */
const SHAPE_CLASSES: Record<SkeletonShape, string> = {
  block: 'rounded-[16px] bg-secondary-200',
  line: 'h-4 rounded-md bg-secondary-200',
  circle: 'rounded-full bg-secondary-200',
};

/**
 * One grey placeholder shape. Inside a {@link SkeletonPulse} it is static and
 * the group breathes; on its own it breathes by itself.
 */
export function Skeleton({ shape = 'block', className, testID }: SkeletonProps) {
  const insidePulse = useInsideSkeletonPulse();
  const classes = cn(SHAPE_CLASSES[shape], className);
  // Standalone, the pulse wrapper IS the shape, so layout classes (`flex-1`,
  // `w-full`) land on the element the parent lays out.
  return insidePulse ? (
    <View className={classes} testID={testID} />
  ) : (
    <SkeletonPulse className={classes} testID={testID} />
  );
}

export const skeletonShapeClass = (shape: SkeletonShape) => SHAPE_CLASSES[shape];
